var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.8 68.4C135.8 105.7 105.6 135.9 68.3 135.9C31.1 135.9 0.799988 105.7 0.799988 68.4C0.799988 31.2 31.1 0.899963 68.3 0.899963C105.6 0.899963 135.8 31.2 135.8 68.4Z",
    fill: "#5A99EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 99.3C28.6 99.4333 30.0333 99.5 31.5 99.5C39.9 99.5 47.6 96.7 53.8 91.8C45.9 91.7 39.3 86.5 37 79.4C38.0667 79.6 39.2 79.7 40.4 79.7C42 79.7 43.5666 79.5 45.1 79.1C36.9 77.4 30.7 70.2 30.7 61.5C30.7 61.4333 30.7 61.3666 30.7 61.3C33.1 62.6 35.9 63.4 38.8 63.5C34 60.3 30.9 54.8 30.9 48.6C30.9 45.3 31.8 42.3 33.3 39.6C42.1 50.4 55.3 57.6 70.2 58.3C69.9333 57.0333 69.8 55.6667 69.8 54.2C69.8 44.3 77.8 36.3 87.7 36.3C92.9 36.3 97.5 38.5 100.8 42C104.9 41.2 108.7 39.7 112.2 37.6C110.8 41.8 108 45.3 104.3 47.5C107.9 47.1 111.4 46.2 114.6 44.7C112.2 48.3 109.1 51.5 105.6 54C105.667 54.8 105.7 55.5666 105.7 56.3C105.7 80 87.7 107.3 54.7 107.3C44.6 107.3 35.1 104.4 27.2 99.3V99.3Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f56ce1bc9eb5120250ac80ed561cf82f.svg";
export { ForwardRef as ReactComponent };